import React, {Component} from 'react';
import {v4 as uuidv4} from 'uuid';
import {BtnVideoIcon, BtnCallIcon} from '../iconsSvg'
import SenderWrapper from "../Body/Sender/wrapper";
import {connect} from "react-redux";

class MenuRender extends Component {
    state = {
        renderCallBtn: false,
        loaderCallMeVideo: false
    }

    handlerChangeRenderCallBtn = () => !this.state.renderCallBtn && this.setState({renderCallBtn: true})

    keyboardMenu = () => {
        let {isMenuData, handlerOnMessage} = this.props;
        let rowCount = Math.max.apply(null, isMenuData.buttons && isMenuData.buttons.map(el => el.row));
        let menus = new Array(rowCount + 1).fill([]);

        const sizeColumn = menuLength => {
            switch (menuLength) {
                case 1:
                    return 'sm-size__1';
                case 2:
                    return 'sm-size__2';
                case 3:
                    return 'sm-size__3';
                case 4:
                    return 'sm-size__4';
                case 5:
                    return 'sm-size__5';
                case 6:
                    return 'sm-size__6';
                default :
                    return;
            }
        };

        const menuRowLength = menus => {
            switch (menus.length) {
                case 1:
                    this.props.handleChangeHeightWithMenu('size__1');
                    break;
                case 2:
                    this.props.handleChangeHeightWithMenu('size__2');
                    break;
                case 3:
                    this.props.handleChangeHeightWithMenu('size__3');
                    break;
                case 4:
                    this.props.handleChangeHeightWithMenu('size__4');
                    break;
                case 5:
                    this.props.handleChangeHeightWithMenu('size__5');
                    break;
                case 6:
                    this.props.handleChangeHeightWithMenu('size__6');
                    break;
                default :
                    break;
            }
        };

        menuRowLength(menus);

        for (let i = 0; i < menus.length; i++) {
            if (isMenuData.buttons.filter(el => el.row === i)) {
                menus[i] = isMenuData.buttons.filter(el => el.row === i);
            }
        }

        const findVideoOrCallId = id => {
            if (id && id === "/CallMeCall") {
                this.handlerChangeRenderCallBtn();

                return 'sm-absolute sm-absolute-call'
            } else if (id && id === "/CallMeVideo") {
                return 'sm-absolute sm-absolute-video'
            }
        }

        const renderBtnText = (id, text) => {
            if (id && id === "/CallMeCall") {
                return BtnCallIcon;
            } else if (id && id === "/CallMeVideo") {
                return BtnVideoIcon;
            } else {
                return <SenderWrapper text={text}/>;
            }
        }

        const callMeVideoClick = itemColPayload => {
            this.setState({loaderCallMeVideo: true}, () => {
                const uuid = uuidv4();

                let spanDynamic = document.getElementById('sm-video-dynamic-id');
                if (spanDynamic) {
                    spanDynamic.setAttribute("data-dynamic-id", uuid);
                }

                let mutationObserverSpan = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (mutation.oldValue === 'false') {
                            mutationObserverSpan.disconnect();
                            let isTrue = spanDynamic.getAttribute('id_registered');
                            if (isTrue === 'true') {
                                handlerOnMessage({
                                        message: {
                                            id: `${itemColPayload.id} ${uuid}`,
                                            type: "COMMAND",
                                            command: "CLICK",
                                            value: itemColPayload.text
                                        },
                                        payload: {
                                            type: "KEYBOARD_SENDER",
                                            payload: {...itemColPayload}
                                        }
                                    }
                                )
                                this.setState({loaderCallMeVideo: false})
                            }
                        }
                    });
                });

                mutationObserverSpan.observe(spanDynamic, {
                    attributeOldValue: true,
                    attributes: true,
                });
            })
        }

        return (<div id="smMenuList" className="sm-menu__list">
            {menus && menus.map((menu, i) => {
                    return (
                        <div className={`sm-menu__item-row ${sizeColumn(menu.length)}`} key={i}>
                            {menu.map((itemCol, iterate) => {
                                    let itemColPayload = itemCol.payload;

                                    return <div className={`sm-menu__item-col ${findVideoOrCallId(itemColPayload.id)}`}
                                                key={iterate}>
                                        {itemCol.url && itemCol.url !== "" ? (
                                            <a
                                                href={itemCol.url}
                                                style={{
                                                    backgroundColor: itemCol.bgColor || window.DEFAULT_BUTTON_BACKGROUND_COLOR || '#005ba8',
                                                    color: itemCol.fontColor ? itemCol.fontColor : '#fff',
                                                    display: "block",
                                                    padding: "10px 0",
                                                    textDecoration: "none"
                                                }}
                                                target="_blank"
                                            >{itemCol.payload.text}</a>) : (
                                            <React.Fragment>
                                                {itemColPayload.id === "/CallMeVideo" ?
                                                    <button
                                                        style={{
                                                            backgroundColor: itemCol.bgColor || window.DEFAULT_BUTTON_BACKGROUND_COLOR || '#005BA8',
                                                            color: itemCol.fontColor ? itemCol.fontColor : '#fff'
                                                        }}
                                                        onClick={() => callMeVideoClick(itemColPayload)}
                                                    >
                                                        {renderBtnText(itemColPayload.id, itemCol.payload.text)}
                                                    </button> : <button
                                                        style={{
                                                            backgroundColor: itemCol.bgColor || window.DEFAULT_BUTTON_BACKGROUND_COLOR || '#005BA8',
                                                            color: itemCol.fontColor ? itemCol.fontColor : '#fff'
                                                        }}
                                                        onClick={() => handlerOnMessage({
                                                                message: {
                                                                    id: itemColPayload.id,
                                                                    type: "COMMAND",
                                                                    command: "CLICK",
                                                                    value: itemColPayload.text
                                                                },
                                                                payload: {
                                                                    type: "KEYBOARD_SENDER",
                                                                    payload: {...itemColPayload}
                                                                }
                                                            }
                                                        )}
                                                    >
                                                        {renderBtnText(itemColPayload.id, itemCol.payload.text)}
                                                    </button>}
                                            </React.Fragment>)}
                                    </div>
                                }
                            )}
                        </div>
                    )
                }
            )}
        </div>)
    };

    render() {
        return (
            <div className={`${this.state.renderCallBtn ? 'with-renderCallBtn' : ''}`}>{this.keyboardMenu()}</div>
        )
    }
}

const mapStateToProps = state => ({
    isMenuData: state.config.isMenuData,
});

export default connect(mapStateToProps, null)(MenuRender);



// WEBPACK FOOTER //
// ./src/components/Menu/menuRender.js